import { useIntl } from 'react-intl';
import { useResendSignupMutation } from 'src/api/mutations/userManagementMutation';
import { useAlerts } from 'src/common/AlertManager';
import useErrorMessages from 'src/hooks/useErrorsMessage';

import styles from '../styles.module.scss';
import messages from '../messages';

interface ResendSignupButtonProps {
  userId: number;
  email: string;
}

const ResendSignupButton = ({ userId, email }: ResendSignupButtonProps) => {
  const { formatMessage } = useIntl();
  const { showSuccess, showAlert } = useAlerts();
  const { getErrorMessage } = useErrorMessages();

  const resendMutation = useResendSignupMutation(userId, {
    onSuccess: () => {
      showSuccess(formatMessage(messages.resendSignupSuccess, { email }));
    },
    onError: (error: any) => {
      showAlert(getErrorMessage(error));
    },
  });

  return (
    <button
      className={styles.resendButton}
      onClick={() => resendMutation.mutate()}
      disabled={resendMutation.isLoading}
    >
      {resendMutation.isLoading ? '...' : formatMessage(messages.resendSignup)}
    </button>
  );
};

export default ResendSignupButton;
